import type { TFacet } from '../models/playlist'

/** Player asset-index key for a facet (URN only; legacy RSS composite keys are no longer used). */
export function facetAssetIndexKey(facet: TFacet & { asset?: string }): string {
  return facet.asset ?? ''
}
